// eslint-disable-next-line import/prefer-default-export
export const GET_PROFILE = 'GET_PROFILE';
